import {
  Box,
  Button,
  Dialog,
  DialogContent,
  InputAdornment,
  OutlinedInput,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip
} from '@mui/material';
import MainCard from 'ui-component/cards/MainCard';
import { dependeciesHelper } from './DependenceHelper';
import { IconSearch } from '@tabler/icons';
import { Visibility } from '@mui/icons-material';
import { styled } from '@mui/material/styles';
import { shouldForwardProp, useTheme } from '@mui/system';
import { useState } from 'react';

const SelectDependenceModal = ({ open, onClose, setDependence, noDependencies = [] }) => {
  const [filter, setFilter] = useState('');
  const theme = useTheme();

  const handlerSelect = (dep) => {
    setDependence(dep);
    onClose(false);
  };

  return (
    <>
      <Dialog open={open} onClose={onClose} maxWidth={'md'} fullWidth>
        <DialogContent>
          <MainCard
            title="Listado de dependencias"
            secondary={
              <Box sx={{ display: { xs: 'none', md: 'block' } }}>
                <OutlineInputStyle
                  id="input-search-header"
                  value={filter}
                  onChange={(e) => setFilter(e.target.value)}
                  placeholder="Buscar dependencia"
                  startAdornment={
                    <InputAdornment position="start">
                      <IconSearch stroke={1.5} size="1rem" color={theme.palette.grey[500]} />
                    </InputAdornment>
                  }
                  aria-describedby="search-helper-text"
                  inputProps={{ 'aria-label': 'weight' }}
                />
              </Box>
            }
          >
            <TableContainer component={Paper}>
              <Table style={{ padding: 100 }}>
                <TableHead>
                  <TableRow>
                    <TableCell>Tipo</TableCell>
                    <TableCell>Siglas</TableCell>
                    <TableCell>Dependencia</TableCell>
                    <TableCell align="center">Seleccionar...</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {dependeciesHelper
                    .filter((dep) => dep.dependence?.toUpperCase().includes(filter.toUpperCase()))
                    .filter((dep) => !noDependencies.includes(dep.dependence))
                    .map((dep, index) => (
                      <TableRow key={index}>
                        <TableCell>{dep.type}</TableCell>
                        <TableCell>{dep.abbreviation}</TableCell>
                        <TableCell>{dep.dependence}</TableCell>
                        <TableCell>
                          <Stack direction="row" justifyContent="center">
                            <Button size="small" variant="text" onClick={() => handlerSelect(dep.dependence)}>
                              <Tooltip title="Seleccionar...">
                                <Visibility />
                              </Tooltip>
                            </Button>
                          </Stack>
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
          </MainCard>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default SelectDependenceModal;

const OutlineInputStyle = styled(OutlinedInput, { shouldForwardProp })(({ theme }) => ({
  width: 434,
  marginLeft: 16,
  paddingLeft: 16,
  paddingRight: 16,
  '& input': {
    background: 'transparent !important',
    paddingLeft: '4px !important'
  },
  [theme.breakpoints.down('lg')]: {
    width: 250
  },
  [theme.breakpoints.down('md')]: {
    width: '100%',
    marginLeft: 4,
    background: '#fff'
  }
}));
